// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/backGround.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.news_container {
    width: 100%;
    height: fit-content;
    display: flex;
    flex-wrap: wrap;
    gap: 19px;
    /* justify-content: space-between; */
    /* overflow-x: auto; */
    align-items: center;
    /* height: 600px; */
}


.video_iframe{
    border-radius: 8px;
}

.news_container::-webkit-scrollbar{
    display: none;
}
.newsCard {
    width: 32%;
    border-radius: 10px;
    border: 1px solid #FFFFFF;
    box-shadow: -6px 10px 40px 0px #00000014;
        padding: 14px 15px 14px 15px;
    display: flex;
    flex-direction: column;
    gap: 7px;
    /* height: 48%; */
    /* justify-content: center; */
    /* align-items: center; */
}

.newsCard > h1 {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
}

.newsImg_section {
    width: 100%;
    height: 177px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
}


.newsImg_section img {
    width: 100%;
    /* height: 35%; */
    border-radius: inherit;
}
.newsparaSection {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 0 !important;
    font-weight: 600 !important;
    color: #4C4949 !important;
}

.newsparaSection  p {
    color: #4C4949 !important;
    font-weight: 600 !important;
    margin: 0 !important;
}
.newsparaSection>div {
    white-space: normal;
    /* display: inline-block; */
    max-width: 100%;
    /* height: 1.5em; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* .newsparaSection>div>p {
    margin-bottom: 8px;
} */

/* .newsparaSection > p:first-child{
    font-size: 18px;
    margin-bottom: 1rem;
} */
.newsparaSection > p:last-child{
    font-size: 14px;
}

.newsViewMoreSec svg {
    width: 18px;
    margin-left: 10px;
}

.newsViewMoreSec {
    display: flex;
    align-items: center;
    /* width: -moz-fit-content; */
    /* width: fit-content; */
    /* justify-content: center; */
}
.newsViewMoreSec:hover{
    cursor: pointer;
}

.newsViewMoreSec > span:first-child {
    font-weight: 700;
    color: #234B9A;
    font-size: 16px;
    /* margin-right: 10px; */
}

h1, h2, div, p, button, span{
    font-family: 'Quicksand' !important;
}

.newFooterPagination{
    margin-top: 12px;
    width: 100%;
}
.newFooterPagination > span:first-child{
    font-size: 16px;
    font-weight: 600;
    color: #000000;
}

.noPostFound{
    font-size: 24px;
    font-weight: 700;
    text-align: center;
}

/* Footer pagination button css */

.newActivePaginationbtn{
    background-color: #E84427 !important;
    color: #FFFFFF !important;
}
.newPaginationBtnGrp{
    gap: 8px;
}

.newsPaginationBtn {
    border: 1px solid #E84427;
    padding: 5px 10px;
    outline: none;
    border-radius: 6px;
    /* width: 2rem; */
    /* height: 2rem; */
    background: transparent;
  
    font-weight: 500;
    font-size: 16px;
    color: #515151;
    display: flex;
    align-items: center;
    justify-content: center;
}
.newsPaginationBtn.next {
    color: #FFFFFF;
    background-color: #E84427;
    padding: 5px 10px !important;
   
    border: 1px solid #E84427;
}

.newsPaginationBtn.pre {
    margin-right: 10px;
}

.newsPaginationBtn.next {
    margin-left: 10px;
}

.mid{
       width: 2rem;
    
    padding: 5px 10px;
}

/* Delete Modal Css */

.modal-title{
    font-weight: 600 !important;
}

.custom-modal .modal-content {
    border-radius: 15px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    padding: 20px;
}



.modal-header-custom.modal-header {
    flex-direction: column-reverse;
}

.modal-content {
    padding: 0 !important;
}

.modal-footer {
    padding: 21px 27px !important;
    flex-wrap: nowrap !important;
    gap: 24px;
}


.cancel-button {
    width: 52% !important;
    background: transparent !important;
    color: black !important;
    box-shadow: none !important;
    border: 2px solid #234B9A !important;
}

.logout-button {
    width: 53% !important;
}

.modal-header-custom {
    border-bottom: none; /* Remove border at the bottom of header */
   
}

.modal-body {
    /* padding: 20px; Adjust padding for body content   */
}

.modal-footer {
    border-top: none; /* Remove border at the top of footer */
   
}



/* News Details CSS */


.newsArticle.newsdescription {
    text-align: justify;
    /* padding-left: 125px !important;
    padding-right: 125px !important; */
}
.newDetailsTitile>svg{
    font-size: 20px;
}
.newDetailsTitile{
    font-size: 20px;
    font-weight: 600;
    color: #000000;
    width:fit-content;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
}
.newsUpdateTime{
    margin-top: 5px !important;
    margin-bottom: 10px !important;
}
.news_details_section{
    display: flex;
    flex-direction: column;
    /* gap: 1rem; */
    justify-content: center;
    align-items: flex-start;
    padding: 0 142px;
}

.news_details_section h1{
    font-size: 20px;
    font-weight: 600;
    color: #000000;
    margin-bottom: 7px;
}

.news_details_section img{
    border-radius: 8px;
    width: 100%;
    height: 410px;
}

.news_details_section > p{
    color: #858080;
    font-size: 14px;
    font-weight: 600;
    margin:0;
    width: 100%;
    /* padding: 0 125px; */
}
.news_container.hello{
    justify-content: center;
} 
.newsdescription p{
    /* text-align: center; */
    margin-top: 15px;
    color: #4C4949;
    font-size: 20px;
    font-weight: 500;
}

/* Video News Css */
.header_news{
    padding: 0 142px !important;
}

.videoNews_container{
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.video_newsSection{
  
    width: 100%;
    height: 410px;
}

.videNewDescription p{
    margin: 0;
}

.news_updateTime{
    color: #4C4949;
    font-size: 20px;
    font-weight: 600;
}

.videoNewUrl{
    font-size: 17px;
    font-weight: 600;
    color: #4C4949;
    /* padding: 0px 125px; */
    width: 100%;
}

.videoNewUrl > a{
    text-decoration: none;
    color: #1D70D2;
}

.videoNewUrl > span:last-child{
    cursor: pointer;
}

.blogsFonts{
    font-size: 20px;
    font-weight: 500;
    color: #4C4949;
}

.newsCard{
    transition: transform 0.3s ease-in-out;
}

.minimizeOpacity {
    opacity: 0.5;
  }

.newsCard:hover{
    /* position: absolute; */
    transform: scale(1.05)
}

@media screen and (max-width:1252px) {
    .newsCard{
        width: 48%;
        justify-content: space-between;
    }
}


@media screen and (max-width:968px) {
    .newsCard{
        width: 100%;
    }
}
@media screen and (max-width:650px) {
    .video_newsSection{
        height: 300px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/News/News.css"],"names":[],"mappings":";AACA;IACI,WAAW;IAEX,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,SAAS;IACT,oCAAoC;IACpC,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;QACpC,4BAA4B;IAChC,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;;AAGA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,oBAAoB;AACxB;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;GAEG;;AAEH;;;GAGG;AACH;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,wBAAwB;IACxB,6BAA6B;AACjC;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,iCAAiC;;AAEjC;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;IACI,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;;IAEvB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,4BAA4B;;IAE5B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;OACO,WAAW;;IAEd,iBAAiB;AACrB;;AAEA,qBAAqB;;AAErB;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,yDAAoD;IACpD,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;AACjB;;;;AAIA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,SAAS;AACb;;;AAGA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB,EAAE,0CAA0C;;AAEnE;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,gBAAgB,EAAE,uCAAuC;;AAE7D;;;;AAIA,qBAAqB;;;AAGrB;IACI,mBAAmB;IACnB;sCACkC;AACtC;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,YAAY;EACd;;AAEF;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,8BAA8B;IAClC;AACJ;;;AAGA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["\n.news_container {\n    width: 100%;\n    height: -moz-fit-content;\n    height: fit-content;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 19px;\n    /* justify-content: space-between; */\n    /* overflow-x: auto; */\n    align-items: center;\n    /* height: 600px; */\n}\n\n\n.video_iframe{\n    border-radius: 8px;\n}\n\n.news_container::-webkit-scrollbar{\n    display: none;\n}\n.newsCard {\n    width: 32%;\n    border-radius: 10px;\n    border: 1px solid #FFFFFF;\n    box-shadow: -6px 10px 40px 0px #00000014;\n        padding: 14px 15px 14px 15px;\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    /* height: 48%; */\n    /* justify-content: center; */\n    /* align-items: center; */\n}\n\n.newsCard > h1 {\n    font-weight: 600;\n    font-size: 16px;\n    color: #000000;\n}\n\n.newsImg_section {\n    width: 100%;\n    height: 177px;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n}\n\n\n.newsImg_section img {\n    width: 100%;\n    /* height: 35%; */\n    border-radius: inherit;\n}\n.newsparaSection {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    margin-bottom: 0 !important;\n    font-weight: 600 !important;\n    color: #4C4949 !important;\n}\n\n.newsparaSection  p {\n    color: #4C4949 !important;\n    font-weight: 600 !important;\n    margin: 0 !important;\n}\n.newsparaSection>div {\n    white-space: normal;\n    /* display: inline-block; */\n    max-width: 100%;\n    /* height: 1.5em; */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* .newsparaSection>div>p {\n    margin-bottom: 8px;\n} */\n\n/* .newsparaSection > p:first-child{\n    font-size: 18px;\n    margin-bottom: 1rem;\n} */\n.newsparaSection > p:last-child{\n    font-size: 14px;\n}\n\n.newsViewMoreSec svg {\n    width: 18px;\n    margin-left: 10px;\n}\n\n.newsViewMoreSec {\n    display: flex;\n    align-items: center;\n    /* width: -moz-fit-content; */\n    /* width: fit-content; */\n    /* justify-content: center; */\n}\n.newsViewMoreSec:hover{\n    cursor: pointer;\n}\n\n.newsViewMoreSec > span:first-child {\n    font-weight: 700;\n    color: #234B9A;\n    font-size: 16px;\n    /* margin-right: 10px; */\n}\n\nh1, h2, div, p, button, span{\n    font-family: 'Quicksand' !important;\n}\n\n.newFooterPagination{\n    margin-top: 12px;\n    width: 100%;\n}\n.newFooterPagination > span:first-child{\n    font-size: 16px;\n    font-weight: 600;\n    color: #000000;\n}\n\n.noPostFound{\n    font-size: 24px;\n    font-weight: 700;\n    text-align: center;\n}\n\n/* Footer pagination button css */\n\n.newActivePaginationbtn{\n    background-color: #E84427 !important;\n    color: #FFFFFF !important;\n}\n.newPaginationBtnGrp{\n    gap: 8px;\n}\n\n.newsPaginationBtn {\n    border: 1px solid #E84427;\n    padding: 5px 10px;\n    outline: none;\n    border-radius: 6px;\n    /* width: 2rem; */\n    /* height: 2rem; */\n    background: transparent;\n  \n    font-weight: 500;\n    font-size: 16px;\n    color: #515151;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.newsPaginationBtn.next {\n    color: #FFFFFF;\n    background-color: #E84427;\n    padding: 5px 10px !important;\n   \n    border: 1px solid #E84427;\n}\n\n.newsPaginationBtn.pre {\n    margin-right: 10px;\n}\n\n.newsPaginationBtn.next {\n    margin-left: 10px;\n}\n\n.mid{\n       width: 2rem;\n    \n    padding: 5px 10px;\n}\n\n/* Delete Modal Css */\n\n.modal-title{\n    font-weight: 600 !important;\n}\n\n.custom-modal .modal-content {\n    border-radius: 15px;\n    background-image: url('../../assets/backGround.png');\n    background-position: center;\n    background-repeat: no-repeat;\n    padding: 20px;\n}\n\n\n\n.modal-header-custom.modal-header {\n    flex-direction: column-reverse;\n}\n\n.modal-content {\n    padding: 0 !important;\n}\n\n.modal-footer {\n    padding: 21px 27px !important;\n    flex-wrap: nowrap !important;\n    gap: 24px;\n}\n\n\n.cancel-button {\n    width: 52% !important;\n    background: transparent !important;\n    color: black !important;\n    box-shadow: none !important;\n    border: 2px solid #234B9A !important;\n}\n\n.logout-button {\n    width: 53% !important;\n}\n\n.modal-header-custom {\n    border-bottom: none; /* Remove border at the bottom of header */\n   \n}\n\n.modal-body {\n    /* padding: 20px; Adjust padding for body content   */\n}\n\n.modal-footer {\n    border-top: none; /* Remove border at the top of footer */\n   \n}\n\n\n\n/* News Details CSS */\n\n\n.newsArticle.newsdescription {\n    text-align: justify;\n    /* padding-left: 125px !important;\n    padding-right: 125px !important; */\n}\n.newDetailsTitile>svg{\n    font-size: 20px;\n}\n.newDetailsTitile{\n    font-size: 20px;\n    font-weight: 600;\n    color: #000000;\n    width:fit-content;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n}\n.newsUpdateTime{\n    margin-top: 5px !important;\n    margin-bottom: 10px !important;\n}\n.news_details_section{\n    display: flex;\n    flex-direction: column;\n    /* gap: 1rem; */\n    justify-content: center;\n    align-items: flex-start;\n    padding: 0 142px;\n}\n\n.news_details_section h1{\n    font-size: 20px;\n    font-weight: 600;\n    color: #000000;\n    margin-bottom: 7px;\n}\n\n.news_details_section img{\n    border-radius: 8px;\n    width: 100%;\n    height: 410px;\n}\n\n.news_details_section > p{\n    color: #858080;\n    font-size: 14px;\n    font-weight: 600;\n    margin:0;\n    width: 100%;\n    /* padding: 0 125px; */\n}\n.news_container.hello{\n    justify-content: center;\n} \n.newsdescription p{\n    /* text-align: center; */\n    margin-top: 15px;\n    color: #4C4949;\n    font-size: 20px;\n    font-weight: 500;\n}\n\n/* Video News Css */\n.header_news{\n    padding: 0 142px !important;\n}\n\n.videoNews_container{\n    width: 100%;\n    height: fit-content;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.video_newsSection{\n  \n    width: 100%;\n    height: 410px;\n}\n\n.videNewDescription p{\n    margin: 0;\n}\n\n.news_updateTime{\n    color: #4C4949;\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.videoNewUrl{\n    font-size: 17px;\n    font-weight: 600;\n    color: #4C4949;\n    /* padding: 0px 125px; */\n    width: 100%;\n}\n\n.videoNewUrl > a{\n    text-decoration: none;\n    color: #1D70D2;\n}\n\n.videoNewUrl > span:last-child{\n    cursor: pointer;\n}\n\n.blogsFonts{\n    font-size: 20px;\n    font-weight: 500;\n    color: #4C4949;\n}\n\n.newsCard{\n    transition: transform 0.3s ease-in-out;\n}\n\n.minimizeOpacity {\n    opacity: 0.5;\n  }\n\n.newsCard:hover{\n    /* position: absolute; */\n    transform: scale(1.05)\n}\n\n@media screen and (max-width:1252px) {\n    .newsCard{\n        width: 48%;\n        justify-content: space-between;\n    }\n}\n\n\n@media screen and (max-width:968px) {\n    .newsCard{\n        width: 100%;\n    }\n}\n@media screen and (max-width:650px) {\n    .video_newsSection{\n        height: 300px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
